import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService }  from "../../services/shared.service";
import { IBrandProfile } from 'src/app/interfaces/brand-profile';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit {

  title: string = 'Disbursements';
  message: string = "Are you sure?";
  confirmButtonText = "Yes";
  cancelButtonText = "Cancel";

  brandProfile!: IBrandProfile;  
  brandStyleTheme: any = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private sharedService: SharedService,
    ) 
    {
      if (data){
        this.title = data.title || this.title;
        this.message = data.message || this.message;
        if (data.buttonText) {
          this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
          this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
        }
      }
    }

  ngOnInit() {
    // Get the current brand profile
    this.brandProfile = this.sharedService.getBrandProfile();
    if (this.brandProfile) {
      this.brandStyleTheme = this.sharedService.getBrandStyleScheme(this.brandProfile);
    }
  }  

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }  

  onCancelClick(): void {
    this.dialogRef.close(false);
  }  

}
